
<template>
  <card
    type="secondary"
    shadow
    header-classes="bg-white pb-5"
    body-classes="px-lg-5 py-lg-5"
    class="border-0"
  >
    <form @submit.prevent>
      <h6 class="heading-small text-muted mb-4">Ayah information</h6>
      <div class="pl-lg-4" style="padding: 0px !important">
        <div class="row" style="padding-bottom: 10px">
          <!-- <div class="col-lg-6">
                    <label class="surah__form__label">Para Number</label>
                    <base-input alternative="" placeholder="Para Number"
                                input-classes="form-control-alternative" v-model="model.paraNum" 
                                type="number" min="1" max="30" @keyup="onKeyUpNumberFields($event, 'paraNum')"
                                class="mb-0" :class="{'input-danger': paraNumErr}" />
                    <span v-show="paraNumErr" class="text-danger" v-text="paraNumMsg"></span>
                </div> -->
          <div class="col-lg-6">
            <label class="surah__form__label">Select Surah</label>
            <select
              class="form-control form-control-alternative custom_input"
              aria-describedby="addon-right addon-left"
              :value="model.surahNum"
              :class="[
                surahNumErr && 'input-danger',
                model.surahNum && $store.getters.arabicFontStyle,
              ]"
              :style="[!model.surahNum ? { 'font-size': '14px' } : {}]"
              @change="alertForChangingSurah"
              style="max-height: 42px"
            >
              <option disabled value="" style="font-size: 14px">
                Select Surah
              </option>
              <option
                v-for="(option, index) in surahs"
                :value="option.value"
                :key="index"
                :class="$store.getters.arabicFontStyle"
              >
                {{ option.label }}
              </option>
            </select>
            <span
              v-show="surahNumErr"
              class="text-danger"
              v-text="surahNumMsg"
            ></span>
          </div>
          <div class="col-lg-6">
            <label class="surah__form__label">Ayah Number</label>
            <base-input
              alternative=""
              placeholder="Ayah Number"
              input-classes="form-control-alternative"
              v-model="model.ayahNum"
              type="number"
              min="1"
              @keyup="onKeyUpNumberFields($event, 'ayahNum')"
              class="mb-0"
              :class="{ 'input-danger': ayahNumErr }"
            />
            <span
              v-show="ayahNumErr"
              class="text-danger"
              v-text="ayahNumMsg"
            ></span>
          </div>
        </div>
        <!-- <div class="row">
                    <div class="col-lg-6">
                        <label class="surah__form__label">Ayah Number</label>
                        <base-input alternative="" placeholder="Ayah Number"
                            input-classes="form-control-alternative" v-model="model.ayahNum"
                            type="number" min="1" @keyup="onKeyUpNumberFields($event, 'ayahNum')" 
                            class="mb-0" :class="{'input-danger': ayahNumErr}" />
                        <span v-show="ayahNumErr" class="text-danger" v-text="ayahNumMsg"></span>
                    </div>
                </div> -->
      </div>
      <hr class="my-4" />
      <h6 class="heading-small text-muted mb-4">Ayah Wording</h6>
      <div class="pl-lg-4" style="padding: 0px !important">
        <div class="row m-0">
          <span
            style="
              font-size: 13px;
              font-weight: 600;
              margin-right: 10px;
              color: #324cdd;
            "
            >Add Ayah word by word</span
          >
          <label class="switch">
            <input
              v-model="ayahMethod"
              @click="setFullAyah"
              type="checkbox"
              id="ayahMethod"
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div
          class="row"
          :style="[!ayahMethod && { opacity: '.4', 'pointer-events': 'none' }]"
        >
          <div class="col-lg-10 pr-0">
            <label class="surah__form__label">Ayah Arabic Word</label>
            <textarea
              placeholder="Enter Ayah Word"
              @input="word = changeIntoArabic($event)"
              v-model="word"
              name="addArbicWord"
              @keypress.enter="addAyahWord"
              :class="[
                wordErr && 'has-danger input-danger',
                word && $store.getters.arabicFontStyle,
              ]"
              rows="1"
              type="text"
              class="mb-0 dir__rtl form-control form-control-alternative custom_input"
              style="padding: 5px 10px 4px 10px; border: 2px solid transparent"
            />
          </div>
          <div class="col-lg-2 pl-0 d-flex align-items-end justify-content-end">
            <base-button type="primary" @click.prevent="addAyahWord"
              >Add Word</base-button
            >
          </div>
        </div>
        <div class="row" v-if="ayahMethod">
          <div class="col-lg-12 p-0">
            <div
              class="mt-3 d-flex"
              style="
                margin-left: 13px !important;
                flex-wrap: wrap;
                flex-direction: row-reverse;
              "
            >
              <span
                v-for="(word, index) in model.ayahWords"
                :key="index"
                :style="!word.arabicWord ? { border: '2px solid red' } : {}"
                class="arabic__word"
                @dblclick="editWord($event, index)"
              >
                <span
                  class="d-flex"
                  :class="$store.getters.arabicFontStyle"
                  v-if="!model.ayahWords[index].toUpdate"
                  data-title="Double click to edit"
                  style="font-size: 24px"
                >
                  {{ word.arabicWord }}</span
                >
                <textarea
                  placeholder="Update word"
                  v-model="word.arabicWord"
                  type="text"
                  class="mb-0 pr-3 custom_input dir__rtl form-control"
                  data-title="Press enter to update"
                  v-if="model.ayahWords[index].toUpdate"
                  @keypress.enter="updateEditedWord(index)"
                  rows="1"
                  :class="$store.getters.arabicFontStyle"
                  @input="word.arabicWord = changeIntoArabic($event)"
                />
                <span
                  v-if="!model.ayahWords[index].toUpdate"
                  @click="deleteWord(index)"
                  class="icon__span cross"
                  data-title="Click to remove"
                  >&#10006;</span
                >
                <span
                  v-if="model.ayahWords[index].toUpdate"
                  @click="word.arabicWord && updateEditedWord(index)"
                  class="icon__span ok"
                  data-title="Click to save"
                  >&#x2714;</span
                >
              </span>
            </div>
          </div>
        </div>
        <hr class="my-4" />
        <div class="row">
          <div class="col-lg-12">
            <label class="surah__form__label">Meanings</label>
          </div>
          <div class="col-lg-12 p-0">
            <div
              class="row m-0 d-flex"
              style="margin-left: 13px !important; flex-direction: row-reverse"
            >
              <div
                v-for="(word, index) in model.ayahWords"
                :key="index"
                class="col-lg-3 py-2 pl-0"
              >
                <label
                  class="d-flex justify-content-end mb-0"
                  :class="$store.getters.arabicFontStyle"
                  style="font-size: 24px"
                  v-html="!word.arabicWord ? '&#160;' : word.arabicWord"
                  >{{ word.arabicWord }}</label
                >
                <base-input
                  :placeholder="'Enter meaning'"
                  input-classes="form-control-alternative"
                  v-model="word.translation"
                  type="text"
                  class="mb-0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="my-4" v-if="model.ayahWords && model.ayahWords.length" />
      <h6 class="heading-small text-muted mb-4">Ayah Translations</h6>
      <div class="pl-lg-4" style="padding: 0px !important">
        <div class="row">
          <div class="col-md-12 mb-3">
            <label class="surah__form__label langNameLabel">Arabština</label>
            <textarea
              :rows="
                (model.ayahWords && model.ayahWords.length) || model.fullAyah
                  ? '2'
                  : '3'
              "
              class="form-control form-control-alternative dir__rtl"
              :class="$store.getters.arabicFontStyle"
              placeholder="Arabština Full Ayah"
              :disabled="ayahMethod"
              :style="[model.fullAyah ? { 'font-size': '24px' } : {}]"
              v-model="model.fullAyah"
              @input="setAyahWords"
              ref="disabledTextArea"
            />
          </div>
          <div
            v-for="(translation, index) in model.ayahTranslations"
            class="col-md-12 mb-3"
            :key="index"
          >
            <label class="surah__form__label langNameLabel">{{
              translation && translation.langName
            }}</label>
            <textarea
              rows="3"
              v-model="model.ayahTranslations[index].translation"
              @keyup="model.ayahTranslations[index].langNameErr = false"
              class="form-control form-control-alternative"
              :placeholder="'Enter ' + translation.langName + ' Translation'"
              v-text="model.ayahTranslations[index].translation"
              :class="{
                'input-danger': model.ayahTranslations[index].langNameErr,
              }"
            />

            <span
              v-show="model.ayahTranslations[index].langNameErr"
              class="text-danger"
              v-text="model.ayahTranslations[index].langNameMsg"
            ></span>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <base-button type="default" class="my-4" @click.prevent="resetForm"
            >Reset</base-button
          >
          <base-button
            type="success"
            class="my-4"
            @click.prevent="updateAyahSubmit"
            >Update Ayah</base-button
          >
        </div>
      </div>
    </form>
  </card>
</template>
<script>
import * as api from "@/apiList";
export default {
  name: "updateAyah",
  props: {
    tableData: Array,
    indexOfUpdatingAyah: Number,
    model: {
      type: Object,
      default: {
        ayahNum: "",
        surahNum: "",
        paraNum: "",
        ayahWords: [],
        fullAyah: "",
        ayahTranslations: [],
      },
    },
  },
  data: function () {
    return {
      arabicLangId: JSON.parse(localStorage.getItem("arabicLangId")),
      languages: JSON.parse(localStorage.getItem("languages")),
      surahs: [],
      word: "",
      updateWord: "",
      updateWordIndex: -1,
      ayahNumErr: false,
      surahNumErr: false,
      paraNumErr: false,
      wordErr: false,
      updateWordErr: false,
      ayahNumMsg: "",
      surahNumMsg: "",
      paraNumMsg: "",

      ayahMethod: true,
      unconfirmedValue: "",
    };
  },
  methods: {
    async updateAyahSubmit() {
      if (this.validateForm()) {
        const update = await api.updateAyah(this.model);
        if (!update.response) {
          this.$toast("Verse Updated Successfully.", {
            position: "top-right",
            timeout: 5000,
            type: "success",
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            icon: true,
            rtl: false,
          });
          this.$emit("refresh", this.model);
        } else {
          this.$toast(update.response.data.message, {
            position: "top-right",
            timeout: 5000,
            type: "error",
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            icon: true,
            rtl: false,
          });
        }
      }
    },
    validateForm() {
      let hasErr = false;
      let instance = this;
      let model_inst = this.model;
      model_inst.ayahTranslations.forEach((elem) => {
        if (!elem.translation || elem.translation == "") {
          if (elem.langName == "Čeština - Hrbek") {
            elem.langNameErr = true;
            elem.langNameMsg = elem.langName + " translation is must";
            hasErr = true;
          }
        }
      });
      Object.keys(this.model).forEach((elem) => {
        if (!model_inst[elem] && elem != "paraNum") {
          instance[elem + "Err"] = true;
          this[elem + "Msg"] = "This field is required.";
          if (elem != "__v") hasErr = true;
        }
      });
      if (!model_inst.ayahWords.length) {
        this.wordErr = true;
      }
      return !hasErr;
    },
    resetForm() {
      this.$confirm({
        title: "Confirmations!",
        message: `Are you sure you want to reset the form because this action is not reveratable`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            Object.keys(this.model).forEach((elem) => {
              if (elem == "ayahTranslations") {
                let target = this.model[elem];
                target.forEach((el) => {
                  el.translation = "";
                });
              } else if (elem == "ayahWords") {
                this.model[elem] = [];
              } else {
                this.model.ayahNum = "";
                this.model.surahNum = "";
                this.model.paraNum = "";
              }
            });
          }
        },
      });
    },
    onKeyUpNumberFields(event, inputName) {
      let { ayahNum, paraNum } = this.model;
      if (inputName == "ayahNum") {
        this.ayahNumErr = false;
        if (ayahNum < 0) {
          this.model.ayahNum = 1;
        }
      }
      if (inputName == "paraNum") {
        this.paraNumErr = false;
        if (paraNum < 0) {
          this.model.paraNum = 1;
        }
        if (paraNum > 30) {
          this.model.paraNum = 30;
        }
      }
    },
    onKeyUpTranslationFields(event, index) {
      this.model.ayahTranslations[index].translationErr = false;
    },

    addAyahWord(e) {
      e.preventDefault();
      let word = this.word.trim();
      console.log("WORD: ", word.length);
      if (word && word.length > 0) {
        this.model.ayahWords.push({ arabicWord: this.word, translation: "" });
        this.word = "";
        this.setFullAyah();
      } else {
        this.wordErr = true;
      }
    },
    deleteWord(index) {
      this.model.ayahWords.splice(index, 1);
      this.setFullAyah();
    },
    async editWord(event, index) {
      console.log(event);
      let newObj = {};
      Object.keys(this.model).forEach((key) => {
        newObj[key] = this.model[key];
      });
      newObj.ayahWords.forEach((el, ind) => {
        if (ind == index) {
          el.toUpdate = true;
        } else {
          el.toUpdate = false;
        }
      });
      this.model = newObj;
    },
    async updateEditedWord(index) {
      let newObj = {};
      newObj = { ...this.model };
      let word = newObj.ayahWords[index];
      if (word.arabicWord.trim().length < 1) {
        return;
      }
      newObj.ayahWords.forEach((el, ind) => {
        if (ind == index) {
          el.toUpdate = false;
        }
      });
      this.model = { ...newObj };
      this.setFullAyah();
    },

    goBack() {
      JSON.stringify(localStorage.removeItem("add-ayah-for-surah-id"));
      this.$router.go(-1);
    },

    async setArabicLangId() {
      this.languages.forEach((elem) => {
        if (elem.name == "Arabština") {
          localStorage.setItem("arabicLangId", JSON.stringify(elem._id));
          this.arabicLangId = elem._id;
          return;
        }
      });
    },
    async getAllSurahs() {
      let getRes = await api.getSurahs();
      if (getRes.status == 200) {
        let recSurahs = getRes.data.data.surahs;
        recSurahs.forEach((elem) => {
          let surahNameObj = { value: elem.surahNum, label: elem.arabicName };
          this.surahs.push(surahNameObj);
        });
      }
    },

    alertForChangingSurah(e) {
      this.surahNumErr = false;
      this.unconfirmedValue = e.currentTarget.value;
      if (this.model.surahNum != this.unconfirmedValue) {
        e.currentTarget.value = this.model.surahNum;
        this.$confirm({
          title: "Confirmations!",
          message: `Are you sure to change the surah? After doing that, this ayah will belong to this surah.`,
          button: {
            no: "No",
            yes: "Yes",
          },
          callback: async (confirm) => {
            if (confirm) {
              this.model.surahNum = this.unconfirmedValue;
            }
          },
        });
      }
    },

    setFullAyah() {
      if (this.ayahMethod) {
        this.wordErr = false;
      }
      const { ayahWords } = this.model;
      let wholePhrase = "";
      ayahWords.forEach((el, index) => {
        wholePhrase += el.arabicWord.trim();
        if (index < ayahWords.length - 1) {
          wholePhrase += " ";
        }
      });
      this.model.fullAyah = wholePhrase;
      this.$refs.disabledTextArea.value = wholePhrase;
      this.$emit("disabledTextArea", wholePhrase);
    },
    setAyahWords(e) {
      let fullAyah = e.target.value;
      fullAyah = this.model.fullAyah = this.changeIntoArabic(e);
      let ayahWords = [];
      let fullAyahWordsArray = fullAyah.split(" ");
      fullAyahWordsArray.forEach((el) => {
        if (el.trim()) {
          let wordExisted = false;
          let wordTranslation = "";
          this.model.ayahWords.forEach((elem) => {
            if (elem.arabicWord == el.trim()) {
              wordExisted = true;
              wordTranslation = elem.translation;
            }
          });
          let obj;
          if (wordExisted) {
            obj = { arabicWord: el.trim(), translation: wordTranslation };
          } else {
            obj = { arabicWord: el.trim(), translation: "" };
          }
          ayahWords.push(obj);
        }
      });
      this.model.ayahWords = ayahWords;
    },

    changeIntoArabic(e) {
      if (e.target.name == "addArbicWord") {
        this.wordErr = false;
        this.updateWordErr = false;
      }
      let val = e.target.value;
      val = val.replace(/`/g, "ذ");
      val = val.replace(/0/g, "۰");
      val = val.replace(/1/g, "۱");
      val = val.replace(/2/g, "۲");
      val = val.replace(/3/g, "۳");
      val = val.replace(/4/g, "٤");
      val = val.replace(/5/g, "۵");
      val = val.replace(/6/g, "٦");
      val = val.replace(/7/g, "۷");
      val = val.replace(/8/g, "۸");
      val = val.replace(/9/g, "۹");
      val = val.replace(/0/g, "۰");
      val = val.replace(/q/g, "ض");
      val = val.replace(/w/g, "ص");
      val = val.replace(/e/g, "ث");
      val = val.replace(/r/g, "ق");
      val = val.replace(/t/g, "ف");
      val = val.replace(/y/g, "غ");
      val = val.replace(/u/g, "ع");
      val = val.replace(/i/g, "ه");
      val = val.replace(/o/g, "خ");
      val = val.replace(/p/g, "ح");
      val = val.replace(/\[/g, "ج");
      val = val.replace(/\]/g, "د");
      val = val.replace(/a/g, "ش");
      val = val.replace(/s/g, "س");
      val = val.replace(/d/g, "ي");
      val = val.replace(/f/g, "ب");
      val = val.replace(/g/g, "ل");
      val = val.replace(/h/g, "ا");
      val = val.replace(/j/g, "ت");
      val = val.replace(/k/g, "ن");
      val = val.replace(/l/g, "م");
      val = val.replace(/\;/g, "ك");
      val = val.replace(/\'/g, "ط");
      val = val.replace(/z/g, "ئ");
      val = val.replace(/x/g, "ء");
      val = val.replace(/c/g, "ؤ");
      val = val.replace(/v/g, "ر");
      val = val.replace(/b/g, "لا");
      val = val.replace(/n/g, "ى");
      val = val.replace(/m/g, "ة");
      val = val.replace(/\,/g, "و");
      val = val.replace(/\./g, "ز");
      val = val.replace(/\//g, "ظ");
      val = val.replace(/~/g, " ّ");
      val = val.replace(/Q/g, "َ");
      val = val.replace(/W/g, "ً");
      val = val.replace(/E/g, "ُ");
      val = val.replace(/R/g, "ٌ");
      val = val.replace(/T/g, "لإ");
      val = val.replace(/Y/g, "إ");
      val = val.replace(/U/g, "‘");
      val = val.replace(/I/g, "÷");
      val = val.replace(/O/g, "×");
      val = val.replace(/P/g, "؛");
      val = val.replace(/A/g, "ِ");
      val = val.replace(/S/g, "ٍ");
      val = val.replace(/G/g, "لأ");
      val = val.replace(/H/g, "أ");
      val = val.replace(/J/g, "ـ");
      val = val.replace(/K/g, "،");
      val = val.replace(/L/g, "/");
      val = val.replace(/Z/g, "~");
      val = val.replace(/X/g, "ْ");
      val = val.replace(/B/g, "لآ");
      val = val.replace(/N/g, "آ");
      val = val.replace(/M/g, "’");
      val = val.replace(/\?/g, "؟");
      e.target.value = val;
      return e.target.value;
    },
  },
  created() {
    if (!this.arabicLangId) {
      this.setArabicLangId();
    }
    this.getAllSurahs();
  },
  mounted: function () {
    // this.setFullAyah();
  },
};
</script>
<style lang="scss" scoped>
.dir__rtl {
  direction: rtl;
  text-align: right;
}
.add__user_cross {
  cursor: pointer;
  position: absolute;
  right: 0 !important;
  top: -12px;
  border: 1px solid #f7fafc;
  background-color: #f7fafc;
  padding: 10px 15px;
  z-index: 9;
  border-radius: 100px;
  color: purple;
}
span.text-danger {
  font-size: 12px !important;
}
.input-danger {
  border: 2px solid red !important;
  border-radius: 7px;
}
.add__surah__form form {
  background: #f7fafc;
  padding: 10px 20px;
  border-radius: 0.375rem;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}
.surah__form__label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}
.surah__form__label.langNameLabel + div {
  margin-bottom: 0px;
}
.close_update_form {
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 12px;
}
.arabic__word {
  user-select: none;
  display: inline-block;
  cursor: pointer;
  position: relative;
  border: 2px solid rgb(158, 157, 157);
  margin-top: 10px !important;
  margin-right: 10px !important;
  padding: 2.5px 15px 2.5px 15px;
  border-radius: 100px;
  box-shadow: 2px 5px 5px 0 rgba(158, 157, 157, 0.2);
  transition: all 0.2s ease-out;
}
.arabic__word textarea {
  padding: 0px;
  border: none;
  background: transparent;
  color: inherit;
  outline: none;
}
.arabic__word:hover {
  padding: 2.5px 30px 2.5px 15px;
}
.arabic__word .icon__span {
  display: none;
  position: absolute;
  top: 10.5px;
  right: 10px;
  color: brown;
  font-weight: 600;
  font-size: 12px;
}
.arabic__word .icon__span.ok {
  display: block;
}
.arabic__word:hover .icon__span {
  display: block;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 18px;

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .slider {
      background-color: #324cdd;
    }
    &:focus + .slider {
      box-shadow: 0 0 1px #324cdd;
    }
    &:checked + .slider:before {
      -webkit-transform: translateX(22px);
      -ms-transform: translateX(22px);
      transform: translateX(22px);
    }
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;

    &:before {
      position: absolute;
      content: "";
      height: 20px;
      width: 20px;
      left: 0px;
      bottom: -1px;
      background-color: white;
      box-shadow: 0 0 5px silver;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    &.round {
      border-radius: 34px;
    }
    &.round:before {
      border-radius: 50%;
    }
  }
}
</style>
